var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"https://img3.quanyou.com.cn/joyNew/group1/M00/61/CE/rB8LrmcE_ByAPJtmAAJrHB7Hh7A567.png","alt":""}})])}]

export { render, staticRenderFns }